"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { ReactNode } from "react";

interface BentoCardProps {
  className?: string;
  Icon?: any;
  name: string;
  description: string;
  href?: string;
  cta?: string;
  background?: ReactNode;
}

export function BentoCard({
  className,
  Icon,
  name,
  description,
  href,
  cta,
  background,
}: BentoCardProps) {
  return (
    <div
      className={cn(
        "group relative overflow-hidden rounded-3xl border border-border/5 bg-white p-8 transition-all duration-500 shadow-sm hover:bg-white/80 dark:bg-white/5 dark:hover:bg-white/10 min-h-[300px]",
        className
      )}
    >
      {background}
      <div className="relative z-10 flex flex-col justify-end h-full">

        <div className="flex items-center justify-between">
          <div>
            {Icon && (
              <Icon className="h-8 w-8 text-foreground/80" />
            )}
          </div>
          {href && cta && (
            <Link
              href={href}
              className="text-sm font-medium text-foreground/80"
            >
              {cta}
            </Link>
          )}
        </div>
        <h3 className="mt-4 text-2xl font-bold text-foreground">
          {name}
        </h3>
        <p className="mt-2 text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
}

export function BentoGrid({ children }: { children: React.ReactNode }) {
  return (
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-4 lg:grid-cols-3 max-md:pb-3 lg:pb-14">
      {children}
    </div>
  );
}
